import React from 'react';

const LogoAlif = () => {
  return (
    <>
      <svg
        width="98"
        height="36"
        viewBox="0 0 98 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1_159)">
          <path
            d="M47.1957 17.7366C47.1957 18.7998 46.816 19.7111 46.1325 20.4705C45.4491 21.2299 44.3859 21.5337 43.3227 21.5337C42.2596 21.5337 41.3483 21.1539 40.6648 20.4705C39.9813 19.7111 39.6776 18.7998 39.6776 17.7366C39.6776 16.6734 40.0573 15.7622 40.6648 15.0787C41.3483 14.3193 42.2596 13.9396 43.3227 13.9396C44.3859 13.9396 45.4491 14.3193 46.1325 15.0787C46.816 15.7622 47.1957 16.5975 47.1957 17.7366ZM47.1198 12.6486C45.9807 11.6614 44.6137 11.2057 43.019 11.2057C41.2723 11.2057 39.5257 11.8132 38.3866 13.0283C37.1715 14.2433 36.64 15.8381 36.64 17.6607C36.64 19.5592 37.2475 21.1539 38.3866 22.369C39.5257 23.66 41.1964 24.2675 43.019 24.2675C44.6897 24.2675 45.8288 23.8119 47.1198 22.8246V23.9638H49.9296V11.4335H47.1198V12.6486Z"
            fill="#222222"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M52.6634 24.1156C54.1823 24.1156 55.3214 23.5081 56.0808 22.2171C56.3845 21.7615 56.6883 21.0021 56.8402 20.5464C57.068 20.0148 57.2199 18.9517 57.3718 18.496C57.4477 18.2682 57.5236 17.8885 57.5996 17.3569L57.7515 16.2937C57.7515 16.0659 57.8274 15.6862 57.9033 15.0787L58.0552 14.0155H60.865V23.9638H63.8267V11.4335H55.4732L55.3214 12.4208C55.0935 14.7749 54.7898 16.6734 54.562 17.9644C54.3341 19.2554 54.0304 20.2427 53.4988 20.9261C53.0431 21.5337 52.4356 21.8374 51.6762 21.8374L51.8281 24.0397C52.2078 24.1156 52.4356 24.1156 52.6634 24.1156Z"
            fill="#222222"
          />
          <path
            d="M90.5578 13.7877C93.4436 13.7877 95.1143 15.3065 95.1143 17.7366C95.1143 20.1667 93.3676 21.6855 90.5578 21.6855V13.7877ZM83.1916 17.7366C83.1916 15.3065 84.8623 13.7877 87.748 13.7877V21.6855C84.8623 21.6096 83.1916 20.1667 83.1916 17.7366ZM98 17.7366C98 15.7622 97.3165 14.1674 95.9496 13.0283C94.5827 11.8132 92.7601 11.2057 90.5578 11.1298V7.78839H87.748V11.1298C85.5457 11.2057 83.6472 11.8132 82.3562 13.0283C80.9893 14.1674 80.3058 15.7622 80.3058 17.7366C80.3058 19.7111 80.9893 21.2299 82.3562 22.369C83.7232 23.5081 85.5457 24.1916 87.748 24.2675V27.6089H90.5578V24.2675C92.836 24.1916 94.6586 23.584 95.9496 22.4449C97.3165 21.2299 98 19.6351 98 17.7366Z"
            fill="#222222"
          />
          <path
            d="M68.2312 23.9638L75.2937 16.1419V23.9638H78.1795V11.4335H76.281L69.2944 19.3314V11.4335H66.3327V23.9638H68.2312Z"
            fill="#222222"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.1206 35.9201C13.6905 35.6922 11.4122 35.0088 9.2859 33.8697C5.26103 31.6674 2.14745 27.9463 0.704571 23.2379C-0.662366 18.5296 0.0211024 13.6694 2.22339 9.72044C5.10914 4.40457 10.6528 0.759409 16.5762 0H16.7281L18.2469 3.79705C18.171 3.79705 18.095 3.79705 18.095 3.79705C13.0829 4.10081 8.07084 7.06251 5.64073 11.543C3.89409 14.6566 3.43844 18.4536 4.50162 22.0988C5.56479 25.8199 8.07084 28.7057 11.1844 30.3764C12.8551 31.2877 14.6777 31.8192 16.5762 32.0471C20.753 32.4268 24.626 31.0598 27.6636 28.6297C27.8155 28.4778 27.9674 28.4019 28.1192 28.25L29.6381 32.0471C25.917 34.8569 21.1327 36.3757 16.1206 35.9201ZM20.2214 8.88509H15.4371L9.13401 24.453H13.2348L17.8672 12.3784L22.4996 24.453H26.6004L20.2214 8.88509Z"
            fill="#39B980"
          />
        </g>
        <defs>
          <clipPath id="clip0_1_159">
            <rect width="98" height="36" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default LogoAlif;
